export const PROD_HOSTNAMES = [
  "mi.peresoberem.org",
  "api.mi.peresoberem.org",
  "new.peresoberem.org",
  "peresoberem.org",
];

export const isProductionHost = PROD_HOSTNAMES.includes(
  window.location.hostname,
);

export const apiHost = isProductionHost ? "https://new.peresoberem.org" : "";

export const apiRoot = apiHost + "/solutions/api/";
export const apiV2Root = apiHost + "/api/v2/";

// ID счётчика Google Analytics; пусто — GA не подключается
export const GA_MEASUREMENT_ID = "G-NJH3NMLBHY";
